import React, { useMemo, useRef, useState } from 'react';

import ecommerce from '../img/ecommerce.png';

import logo from "../img/logo/Logo.png"
import { Link, useNavigate } from 'react-router-dom';
import { FaSignInAlt } from 'react-icons/fa'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import axios from '../apis/axios';
import { useAuth } from '../hooks/appHooks';
import LanguageSelector from "../utils/LanguageSelector.jsx"
import { useTranslation } from 'react-i18next';

// const SEND_OTP_URL = "/users/send-otp";
const LOGIN = "/users/login";

const Login = () => {
    const [attemps, setAttempts] = useState(0);
    const { setAuth } = useAuth()
    const phoneRef = useRef(null);
    const passwordRef = useRef(null);
    const { t, i18n } = useTranslation();
    const tLogin = t("login");
    const navigate = useNavigate()

    const handleSendOtpCode = async (e) => {
        e.preventDefault();

        const phone = phoneRef.current.value;
        const password = passwordRef.current.value;

        try {
            const { data: response } = await axios.post(LOGIN,
                JSON.stringify({ phone, password }),
                { headers: { 'Accept-Language': i18n.language, 'Content-Type': 'application/json' } });

            localStorage.setItem("session_token", response?.data.accessToken)
            localStorage.setItem("refresh_token", response?.data.refreshToken)

            setAuth({ ...response?.data, token: response?.data.accessToken })
            const from = response?.data?.role?.includes("VENDOR") ? "/vendor" : "/admin" // "/" to navigate to admin -- "/vendor" to navigate to vendors

            navigate(from, { replace: true })
            toast.success(response?.data?.message);
        } catch (error) {
            toast.error(error?.response.data.message);
            setAttempts((val) => val + 1)
        }
    }

    return (
        <div className=''>
            <ToastContainer />
            <div className='flex'>
                {/* <div className={i18n.dir()==="rtl"?'flex':'flex body_bg'}> */}
                <div className='flex flex-col justify-center my-10 px-10 md:w-1/2 lg:w-1/2'>
                    <div className='flex justify-between mx-12'>
                        <div className=''>
                            <img src={logo} width={200} height={150} alt='logo' />
                        </div>
                        {/* <h2 className='uppercase'>
                            <sub className='m-2 bg-white font-extrabold p-2 rounded-xl'>
                                {tLogin.title} <span><FaSignInAlt style={{ display: 'inline' }} /></span>
                            </sub>
                        </h2> */}
                        <div className='w-32 md:hidden'>
                            <LanguageSelector />
                        </div>
                    </div>
                    <h3 className="text-lg font-normal md:text-lg mx-12 my-6 text-black/60">
                        {tLogin.subtitle}
                    </h3>
                    <form className="space-y-2 md:space-y-4 py-12 mx-12" onSubmit={handleSendOtpCode} method='post'>
                        <div>
                            <label htmlFor="phone" className="mb-2 text-base">{tLogin.phoneLabel}</label>
                            <input ref={phoneRef} type='text' name="phone" id="phone" className="sm:text-xl bg-slate-100 rounded-lg w-full px-5 py-3" placeholder="0512345678" minLength={10} maxLength={10} required />
                        </div>
                        <div>
                            <label htmlFor="password" className="mb-2 text-base">{tLogin.passwordLabel}</label>
                            <input ref={passwordRef} type='password' name="password" id="password" className="sm:text-xl bg-slate-100 rounded-lg w-full px-5 py-3" placeholder="" required />
                        </div>
                        <button type="submit" className="font-extrabold uppercase w-full text-white bg-primary-color px-5 py-2.5 shadow-3">{tLogin.title}</button>
                        {attemps >= 3 ? <div>
                            <Link className="mt-12" to={"/forgot-password"}>{tLogin.forgotPassword}</Link>
                        </div>
                            : ""}
                        {/* <button type="submit" className="font-extrabold uppercase w-full text-white bg-primary-color px-5 py-2.5 shadow-lg">{tLogin.sendBtnText}</button> */}
                    </form>
                </div>

                <div className='hidden md:block md:w-1/2 transparent_bg'>
                    <div className='login_svg_bg p-8 flex justify-end items-start min-h-screen'>
                        <img src={ecommerce} width={400} height={100} alt='login_svg_bg' className='self-end' />
                        <div className='w-32'>
                            <LanguageSelector />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login